import { render, staticRenderFns } from "./WaiverCheckboxesController.vue?vue&type=template&id=73d36aba&scoped=true&"
import script from "./WaiverCheckboxesController.vue?vue&type=script&lang=js&"
export * from "./WaiverCheckboxesController.vue?vue&type=script&lang=js&"
import style0 from "./WaiverCheckboxesController.vue?vue&type=style&index=0&id=73d36aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d36aba",
  null
  
)

export default component.exports